define.alias("shared/components/shared/ui/search-box/result-blank", "calendar/components/shared/ui/search-box/result-blank");